var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import _ from 'lodash';
import { $loader } from 'ziphy-web-shared/basic/utils';
import styles from './FormBuilder.module.scss';
import Elements from './ui/elements/Elements';
const FormBuilder = forwardRef(({ formBuilder, forceRenderType, className }, formRef) => {
    if (forceRenderType === 'plain' && formBuilder.builder.renderType !== 'plain') {
        formBuilder = _.cloneDeep(formBuilder);
        formBuilder.builder.SET_RENDER_TYPE('plain');
    }
    const { form, builder, onSubmit } = formBuilder;
    const handleSubmit = form.submit((data) => __awaiter(void 0, void 0, void 0, function* () {
        yield onSubmit(data);
    }));
    return (_jsx("form", Object.assign({ id: form.id, onSubmit: $loader.registerHandler(form.id, handleSubmit), className: classNames(styles.container, className), ref: formRef }, { children: _jsx(Elements, { "$element": builder }) })));
});
export default observer(FormBuilder);
